// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__RO+0J","mobileContainer":"LoginPage_mobileContainer__wIKsO","logo":"LoginPage_logo__5Jqcw","toast":"LoginPage_toast__R+Uo2"};